// Swap these placeholders with real testimonials from friends.
// Fields: name (first name only), age (number), occupation (string),
// gender ("m" | "f" | "nb"), quote (string), photo (string, optional).
// When `photo` is omitted, a small monochrome silhouette icon is shown
// inside a circular avatar — the silhouette encodes gender.
export const testimonials = [
  {
    name: "Andrei",
    age: 32,
    occupation: "Backend engineer",
    gender: "m",
    quote:
      "I'd start a routine, drop it two weeks in, blame myself. Lucian rebuilt the routine so dropping it wasn't the failure mode. Six months in I'm still lifting three times a week without thinking about it.",
  },
  {
    name: "Veronica",
    age: 25,
    occupation: "Product designer",
    gender: "f",
    quote:
      "Calls are calm and direct. No pep talks, no jargon. He asked better questions than my therapist and I actually did the homework.",
  },
  {
    name: "Joseph",
    age: 41,
    occupation: "Engineering manager",
    gender: "m",
    quote:
      "Half the value was Lucian pointing out things I already knew but kept ignoring. The other half was giving me a way to act on them that didn't require willpower.",
  },
  {
    name: "Alex",
    age: 27,
    occupation: "Founder",
    gender: "nb",
    quote:
      "Hired him for gym and nutrition, stayed for the work-life stuff. Systems person first, which is why the advice sticks.",
  },
  {
    name: "Mike",
    age: 25,
    occupation: "-",
    gender: "m",
    quote:
      "Honestly I mostly just needed someone who'd listen without trying to fix me on the spot. He gets it, kudos",
  },
  {
    name: "-",
    age: 26,
    occupation: "-",
    gender: "f",
    quote:
      "I came in with 'I don't know what I want'and left with something that at least felt like a direction, i'll update my review after afew more sessions",
  },
  {
    name: "Cristi",
    age: 44,
    occupation: "Small biz owner",
    gender: "m",
    quote:
      "if you want someone who thinks before he talks, he's rare.",
  },
  {
    name: "Jessica",
    age: 23,
    occupation: "-",
    gender: "f",
    quote:
      "He's not soft, but he's not one of those 'man up' coaches either. Somewhere in between. I appreciated that he didn't oversell what he could do.",
  },
  {
    name: "Sam",
    age: 28,
    occupation: "Freelance illustrator",
    gender: "nb",
    quote:
      "we talked about my sleep for an hour once and it was more useful than I expected.",
  },
  {
    name: "Ole",
    age: 25,
    occupation: "Dentist",
    gender: "m",
    quote:
      "I hate the word 'coaching' but i found value",
  },
  {
    name: "Alena",
    age: 46,
    occupation: "Teacher",
    gender: "f",
    quote:
      "good",
  },
  {
    name: "Lucas",
    age: 24,
    occupation: "-",
    gender: "m",
    quote:
      "He didn't try to sell me a bigger package. That alone made me trust him more. Also, he was right about the caffeine.",
  },
  {
    name: "Ana",
    age: 33,
    occupation: "Therapist",
    gender: "f",
    quote:
      "I'm a therapist myself so I'm picky. Grateful for the clarity",
  },
  {
    name: "Rob",
    age: 51,
    occupation: "Retired",
    gender: "m",
    quote:
      "I retired earlier than expected and the days got weird. Talking to Lucian gave a shape to the week. Nothing dramatic. That was the point.",
  },
  {
    name: "Sara",
    age: 23,
    occupation: "Marketer",
    gender: "f",
    quote:
      "Half our calls I just complained. He never rushed me to 'set a goal.' At some point I stopped needing to complain. Not sure if that's him or me but I'll take it.",
  },
  {
    name: "Aryan",
    age: 30,
    occupation: "Product manager",
    gender: "m",
    quote:
      "Direct guy. Doesn't waste your time. Won't tell you what you want to hear. If you're in a slump and need honest input, book the call.",
  },
  {
    name: "Miruna",
    age: 25,
    occupation: "Nurse",
    gender: "f",
    quote:
      "After a long shift I'm not in the mood to be 'coached.' He gets it. We talk normally. The advice comes wrapped in a normal conversation.",
  },
  {
    name: "Peter",
    age: 42,
    occupation: "-",
    gender: "m",
    quote:
      "I don't do the self-improvement thing. My wife pushed me to try one call. I've kept booking them. Whatever it is he's doing, it's not annoying.",
  },
  {
    name: "Andrada",
    age: 25,
    occupation: "PhD student",
    gender: "f",
    quote:
      "Useful for people in the middle of a decision. Less useful if you already know what you want to do, but you probably wouldn't book a call in that case.",
  },
];
